<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="form-group form-label-group">
    <input type="text" id="registerInputEmail" class="form-control" formControlName="email" required/>
    <label for="registerInputEmail" i18n="Input Label@@register.form.email.label">Email address</label>
    <div *ngIf="registerForm.controls.email.pending" class="spinner sk-fading-circle">
      <div class="sk-circle1 sk-circle"></div>
      <div class="sk-circle2 sk-circle"></div>
      <div class="sk-circle3 sk-circle"></div>
      <div class="sk-circle4 sk-circle"></div>
      <div class="sk-circle5 sk-circle"></div>
      <div class="sk-circle6 sk-circle"></div>
      <div class="sk-circle7 sk-circle"></div>
      <div class="sk-circle8 sk-circle"></div>
      <div class="sk-circle9 sk-circle"></div>
      <div class="sk-circle10 sk-circle"></div>
      <div class="sk-circle11 sk-circle"></div>
      <div class="sk-circle12 sk-circle"></div>
    </div>
    <div *ngIf="registerForm.controls.email.invalid && (registerForm.controls.email.dirty || registerForm.controls.email.touched)" class="invalid-tooltip">
      <div *ngIf="registerForm.controls.email.errors.required" i18n="Error message when no email is provided@@register.form.errors.email.required">Email is required.</div>
      <div *ngIf="registerForm.controls.email.errors.email" i18n="Error message when email is no valid address@@register.form.errors.email.invalid">Email needs to be a valid address.</div>
      <div *ngIf="registerForm.controls.email.errors.emailAlreadyRegistered" i18n="Error message when email address is already taken@@register.form.errors.email.alreadyRegistered">Email is already registered! Please <a [routerLink]="['', {outlets: { modal: ['login']}}]" skipLocationChange>login</a> instead!</div>
    </div>
  </div>
  <div class="form-group form-label-group">
    <input type="password" id="registerInputPassword" class="form-control" formControlName="password" required />
    <label for="registerInputPassword" i18n="Input Label@@register.form.password.label">Password</label>
    <div *ngIf="registerForm.controls.password.invalid && (registerForm.controls.password.dirty || registerForm.controls.password.touched)" class="invalid-tooltip">
      <div *ngIf="registerForm.controls.password.errors.required" i18n="Error message when no password is provided@@register.form.errors.password.required">Password is required.</div>
      <div *ngIf="registerForm.controls.password.errors.minlength" i18n="Error message when password hasn't reach min-lenght@@register.form.errors.password.minLength">Password needs to be at least 4 characters long!</div>
    </div>
  </div>
  <div class="form-group my-4">
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="registerInputNewsletter" formControlName="newsletter">
      <label class="custom-control-label" for="registerInputNewsletter">Travian Games newsletter</label>
    </div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="registerInputToc" formControlName="toc">
      <label class="custom-control-label" for="registerInputToc" i18n="Input Label for Terms and Conditions@@register.form.toc.label">I have read and accept the <a href="">General Terms and Conditions</a></label>
      <div *ngIf="registerForm.controls.toc.invalid && (registerForm.controls.toc.dirty || registerForm.controls.toc.touched)" class="invalid-tooltip">
        <span i18n="Error message when Terms & Conditions are not accepted@@register.form.errors.toc.required">You have to accept our Terms & Conditions.</span>
      </div>
    </div>
  </div>
  <div class="text-center">
    <div class="btn-primary-container">
      <button type="submit" class="btn btn-primary">
        <span i18n="Register Form Submit button@@register.form.submit.label">Sign Up</span>
      </button>
    </div>
  </div>
</form>
